module.exports = __webpack_public_path__ + "images/emoji/sailboat.9f26e69d1abda899c035.png";